module.exports = "/_next/static/images/logo--full-b8aa60cf427df746fb432dedd4f806d9.svg";